import dom from 'OK/utils/dom';
import logger from 'OK/logger';
import vanilla from 'OK/utils/vanilla';
import utils from 'OK/utils/utils';
import StickyBannerContainer from 'OK/banners/StickyBannerContainer';
import smokescreen from 'OK/Smokescreen';
import Welter from 'mrg-smokescreen/Welter';
import Utils from 'mrg-smokescreen/Utils';
import blockDetect from 'OK/banners/blockDetect/blockDetect';
import SmokescreenImgStyle from 'OK/banners/SmokescreenImgStyle';
import ViewportTracker from 'OK/ViewportTracker';
import { ACTIVATE_MONEY_SAVE } from 'OK/MsEventBus';

/**
* Модуль для механизма обхода адблока
*
* @module OK/banners/moneySave
*/

var LogSuccess = "nb_success";
var LogError = "nb_error";
var LeftGwtBannerPlaceId = 'hook_ViewportHeightAwareBanner_ViewportHeightAwareBannerInner',
    LeftRbExtBannerPlaceId = 'LeftColumnBannerInner';

// Управляющие параметры, получаются из PMS.
var mimicUrl = 'wss://ad.mail.ru/mimic/v1/ws';
var tplV2Enabled = false;
var topRightBannerEnabled = true;
var messagesBannerEnabled = true;
var discussionsBannerEnabled = true;
var bottomLeftBannerEnabled = true;
var smokescreenTopRightEnabled = false;
var smokescreenDiscussionsEnabled = false;
var smokescreenMessagesEnabled = false;
var smokescreenBottomLeftEnabled = false;
var smokescreenRandomizeCss = false;
var statId = {
    topRight: '',
    message: '',
    discussion: '',
    bottomLeft: ''
};
var pixelId = {
    topRight: '',
    message: '',
    discussion: '',
    bottomLeft: ''
};
var numAds = {
    topRight: 3,
    message: 3,
    discussion: 3,
    bottomLeft: 5
};
var pageId = '';
var refreshEnabled = false;
var refreshInterval = {
    topRight: -1,
    message: -1,
    discussion: -1,
    bottomLeft: -1
};
var whitelistSelector = '';
var useHttp;
var secretCmd = '';
var secretFeedReplaceCmd = '';
var debugOrigin = '';
var hideBannersUnderLayer = false;

var MO = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

var get = dom.byClass;
var get1st = dom.firstByClass;

var locatorLinks;
var locator;

var onActivated;
var activated = new Promise(function (resolve) {
    onActivated = resolve;
});

var onHooksReady;
var hooksReady = new Promise(function (resolve) {
    onHooksReady = resolve;
});

var adLinksRedirectWrapperEnabled;
var redirectLinkToken;

var redesignEnabled = false;
var sendPixelsThroughServer = false;

function addStyle(el, style) {
    var s = el.getAttribute('style') || '';
    el.setAttribute('style', s.indexOf(style) !== -1 ? s : s + style);
}

function setDisplayNone(el) {
    el.setAttribute('style', 'display: none !important');
}

var imageStyles = {
    bottomLeft: new SmokescreenImgStyle('bottomLeft'),
    topRight: new SmokescreenImgStyle('topRight')
};

var OldContainerIds = {
    leftAdCont: 'mainContentLeftColumn',
    leftAdWrapper: 'leftColumn',
    hookBlockMainContent: 'hook_Block_MainContent'
};

var Web2k19ContainerIds = {
    leftAdCont: 'hook_Block_AsideColumn',
    leftAdWrapper: 'hook_Block_AsideColumn',
    hookBlockMainContent: 'hook_Block_MainContent2'
};

var containerIds = OldContainerIds;

function checkWeb2k19() {
    if (redesignEnabled) {
        var mainContent2 = document.getElementById('hook_Block_MainContent2');
        if (mainContent2) {
            containerIds = Web2k19ContainerIds;
        } else {
            containerIds = OldContainerIds;
        }
    }
}

/**
 * Рекурсивно обходим блок и убираем видимость его частям. Нужно, если пользователь сам решил скрыть рекламу
 */
function clear(root) {
    var children = root.children;
    root.removeAttribute('style');
    var len = children.length;
    for (var i = 0; i < len; i++) {
        var child = children[i];
        if (child.classList.contains('delete-stub')) {
            continue;
        }
        if (child.tagName === 'DIV') {
            clear(child);
        }
    }
}

var activateLocator;

activateLocator = function() {
    return activated.then(function () {
        if (smokescreenRandomizeCss) {
            // численные значения width в стилях будут заменены на calc() со случайными аргументами
            locator = smokescreen.getLocator(['width']);
        } else {
            locator = smokescreen.getLocator();
        }

        if (smokescreenBottomLeftEnabled) {
            imageStyles['bottomLeft'].createStyleEl();
        }
        if (topRightBannerEnabled) {
            imageStyles['topRight'].createStyleEl();
        }

        var result = locator.updateSheets(locatorLinks);

        activateLocator = function () {
            return result;
        };

        return result;
    })

};

function applySmokescreen(bannerPlace, method) {
    var logName = bannerPlace + "Smokescreen";
    try {
        activateLocator()
            .then(method)
            ['catch'](
                function (reason) {
                    logger.success(LogError, logName, reason);
                });
    } catch (e) {
        logger.success(LogError, logName, e);
    }
}

/**
 * Если включено для данного баннера, то обфусцируем DOM вокруг рекламы, чтобы адблок ее не нашел.
 * Вместе с блоком рекламы, помещаем в зашумленное дерево функциональные части портала,
 * чтобы дерево нельзя было скрыть целиком.
 * Внутри блока рекламы заменяем ид и классы на обфусцированные, удаляем специфичные аттрибуты.
 */
function adjustDOM(adPlace, adCont, bannerPlace, afterAction) {
    if (smokescreenBottomLeftEnabled && bannerPlace === 'bottomLeft') {
        if (adPlace.narrow) {
            var bannerContainer = document.getElementById('hook_Block_ViewportHeightAwareBanner');
            if (bannerContainer) {
                bannerContainer.classList.add('__narrow');
            }
        }
        applySmokescreen(bannerPlace,
            function() {
                var leftColumn = document.getElementById(containerIds.leftAdWrapper);
                if (!leftColumn) return;

                var cont = document.getElementById('hook_Block_StickyBannerContainer');
                if (cont) {
                    leftColumnCssClassesHack();
                    obfuscateChildren(cont, ['#hook_Block_CompactFooter']);
                    locator.wrap(['#hook_Block_StickyBannerContainer'], leftColumn);

                    Welter.wrap(leftColumn, '#' + containerIds.leftAdWrapper + ' > [id^="hook_Block"]');

                    var hookObj = getHookObjWithLocator("stickyBannerHook");
                    if (hookObj)
                        hookObj.applySmokescreen(locator);
                } else {
                    obfuscateChildren(adPlace, ['#hook_Block_CompactFooter'], true);
                }
                imageStyles['bottomLeft'].updateStylesheet(locator);

                afterAction();
                detachElementAndProcessJsLinks(adPlace, bannerPlace);

            });
    } else if (bannerPlace === 'topRight' && smokescreenTopRightEnabled) {

        applySmokescreen(bannerPlace, function () {

            obfuscateChildren(adPlace, false, true);
            processHooks(adPlace, bannerPlace);

            imageStyles['topRight'].updateStylesheet(locator);

            afterAction();

        });

    } else {
        afterAction();
    }
}

// пересоздает элемент в DOM-е, чтобы все предыдущие ссылки на него оказались недействительными
// возвращает ссылку на новый элемент
function detachElementAndProcessJsLinks(node, bannerPlace) {
    var parent = node.parentNode;
    if (!parent) return;

    var clonedNode = node.cloneNode(true);

    processHooks(clonedNode, bannerPlace);

    parent.replaceChild(clonedNode, node);

    return clonedNode;
}


var CLASS_MENU_EXPANDED = '__expanded';

/**
 * @param {HTMLElement} el
 * @param {string} bannerPlace
 */
function CloseHook(el, bannerPlace) {
    this.el = el;
    this.onClick = this.onClick.bind(this);
    this.el.addEventListener("click", this.onClick);
}

CloseHook.prototype.onClick = function (el) {
    this.el.classList.toggle(locator.transform(CLASS_MENU_EXPANDED));
};

CloseHook.prototype.destroy = function() {
    this.el.removeEventListener("click", this.onClick);
};



/**
 * @param {HTMLElement} el
 * @param {string} bannerPlace
 */
function LinkHook(el, bannerPlace) {
    this.el = el;
    var link = el.getAttribute('data-nbh');
    if (link) {
        this.onClick = onJsLinkClick.bind(el, link, bannerPlace);
        this.el.addEventListener("click", this.onClick);
    }
    this.el.removeAttribute('data-nbh');
}

LinkHook.prototype.destroy = function () {
    if (this.onClick) {
        this.el.removeEventListener("click", this.onClick);
    }
}

/**
 * @param {HTMLElement} el
 * @param {string} bannerPlace
 */
function CloseLinkHook(el, bannerPlace) {
    this.el = el;
    this.bannerPlace = bannerPlace;
    this.options = JSON.parse(el.getAttribute('data-options'));
    this.onClick = this.onClick.bind(this);
    this.el.addEventListener("click", this.onClick);
    this.el.removeAttribute('data-options');
}

CloseLinkHook.prototype.onClick = function (event) {
    var options = this.options;
    if (options.clickLink) {
        onJsLinkClick(options.clickLink, this.bannerPlace, event)
    }
    if (options.url) {
        sendPixel(options.url);
    }
    var close = dom.parent(event.target, locator.transform('b-context__close'));
    if (close) {
        close.classList.remove(locator.transform(CLASS_MENU_EXPANDED));
    }
    if (options.shouldCloseAd) {
        var ad = dom.parent(event.target, locator.transform('b-js_ad'));
        if (ad) {
            ad.classList.add('invisible');
        }
    }
    event.stopPropagation();
    event.preventDefault();
};

CloseLinkHook.prototype.destroy = function() {
    this.el.removeEventListener("click", this.onClick);
};

/**
 * @param {HTMLElement} el
 * @param {string} bannerPlace
 */
function AdHook(el, bannerPlace) {
    this.el = el;
    this.options = JSON.parse(this.el.getAttribute('data-options'));
    this.pixels = this.options.common;

    if (this.pixels.render_block_pixel) {
        sendPixel(this.pixels.render_block_pixel);
    }

    if (this.pixels.block_pixel) {
        this.checkVisibility = this.checkVisibility.bind(this);
        this.onVisible = this.onVisible.bind(this);
        ViewportTracker.add(this.el, this.onVisible, this.checkVisibility);
    }

    this.el.removeAttribute('data-options');
}

AdHook.prototype.checkVisibility = function() {
    if (!inDom(this.el)) {
        return false;
    }
    return utils.isElementInViewport(this.el);
}

AdHook.prototype.onVisible = function(visible) {
    if (!visible) {
        return;
    }
    if (this.pixels.block_pixel) {
        ViewportTracker.remove(this.el);
        sendPixel(this.pixels.block_pixel);
    }
}

AdHook.prototype.destroy = function() {
    if (this.pixels.block_pixel) {
        ViewportTracker.remove(this.el);
    }
};

var hooks = {
    ad: AdHook,
    link: LinkHook,
    close: CloseHook,
    closeLink: CloseLinkHook
};

var hooksList = [];

function inDom(el) {
    return !!el.closest('body');
}

function cleanHooks() {
    for (var i = hooksList.length - 1; i >= 0; i--) {
        var hook = hooksList[i];
        if (!inDom(hook.el)) {
            hook.destroy();
            hooksList.splice(i, 1);
        }
    }
}

function processHooks(parentNode, bannerPlace) {

    var elements = parentNode.getElementsByClassName(locator.transform('b-js__hook'));

    for (var li = 0; li < elements.length; li++) {
        var moneySaveHookName = elements[li].getAttribute('data-msh');
        if (moneySaveHookName != null && hooks.hasOwnProperty(moneySaveHookName)) {
            hooksList.push(
                new hooks[moneySaveHookName](elements[li], bannerPlace)
            );
        }
        elements[li].removeAttribute('data-msh');
    }
}

/**
 * smokescreen неверно патчит css для правил, в которых перемешаны нормальные и обфусцированные имена.
 * В качестве воркараунда добавим классов верхнему из обфусцированных элементов
 */
function leftColumnCssClassesHack() {
    var mainContent = document.getElementById('mainContent');
    var stickyBannerCnt = document.getElementById('hook_Block_StickyBannerContainer');
    var layoutAside = document.querySelector('.layout-aside');
    if (mainContent && stickyBannerCnt) {
        if (mainContent.classList.contains('narrow-feed')) {
            stickyBannerCnt.classList.add('narrow-feed');
        }
        if (mainContent.classList.contains('profile-v2')) {
            stickyBannerCnt.classList.add('profile-v2');
        }
        if (mainContent.classList.contains('wide-profile')) {
            stickyBannerCnt.classList.add('wide-profile');
        }
        if (mainContent.classList.contains('mainContentDoubleColumn')) {
            stickyBannerCnt.classList.add('mainContentDoubleColumn');
        }
    } else if (!mainContent && stickyBannerCnt) {
        stickyBannerCnt.classList.add('layout-container');
    }
    if (layoutAside && stickyBannerCnt) {
        stickyBannerCnt.classList.add('layout-aside');
    }

}

function obfuscateContainer(id, skipNodes) {
    var container = document.getElementById(id);
    if (container) obfuscateChildren(container, skipNodes);
}

function obfuscateChildren(container, skipNodes, skipContainer) {
    if (skipNodes) {
        for (var ni = 0; ni < skipNodes.length; ++ni) {
            if (container.matches(skipNodes[ni])) {
                return;
            }
        }
    }
    if (!skipContainer) {
        obfuscateElement(container);
    }
    var children = container.children;
    var len = children.length;
    for (var i = 0; i < len; i++) {
        obfuscateChildren(children[i], skipNodes);
    }
}

function obfuscateElement(el) {
    if (el.id) el.id = locator.transform(el.id);
    if (el.className) {
        el.className = locator.transform(el.className);
    } else {
        el.removeAttribute('class');
    }

    // скользкий код, удаляющий аттрибуты. Сохраняем данные для OK/NativeHookJs
    var attributes = [
        'data-module',
        'data-place',
        'data-name',
        'data-params',
        'data-dependencies',
        'data-fallback',
        'jsplace'
    ];

    var okData = {};

    attributes.forEach(function(attr) {
        if (el.hasAttribute(attr)) {
            okData[attr] = el.getAttribute(attr);
            el.removeAttribute(attr);
        }
    });

    if (okData.hasOwnProperty('jsplace') || (el.getAttribute('style') === "")) {
        el.removeAttribute('style');
    }

    el.okData = okData;
}

function get1stWithLocator(root, classname) {
    var el = get1st(root, classname);

    if (el) {
        return el;
    } else if (locator) {
        return get1st(root, locator.transform(classname));
    } else return null;
}

function getHookObjWithLocator(classname) {
    var hookDiv = get1stWithLocator(document, classname);
    var hookObj = hookDiv ? hookDiv.nativeHookImpl : null;
    return hookObj;
}


function check(item) {
    if (!item) {
        return;
    }
    // Реклама - все что содержит баннер враппер
    var wrp = get1st(item, 'js-banner-wrapper');
    if (wrp) {

        // Следим за событиями закрытия рекламы по крестику
        var closeElem = get1st(item, 'feed_close');
        if (closeElem) {
            closeElem.addEventListener("click", function() {
                clear(item);
            });
        }
    }
}

/**
 * Отслеживаем события в ленте и показываем заблокированные элементы
 */
function watchFeed() {
    var container = get1st(document, 'feed-list');

    if (container) {
        var feeds = container.children;
        var len = feeds.length;
        for (var ind = 0; ind < len; ind++) {
            check(feeds[ind]);
        }
        if (MO) {
            var
                config = { attributes: false, childList: true, characterData: false },
                observer = new MO(function(mutations) {
                    mutations.forEach(function(mutation) {
                        var node = mutation.addedNodes[0];
                        if (node && (node instanceof Element)) {
                            var feed = get1st(node, 'feed');
                            check(feed);
                        }
                    });
                });
            observer.observe(container, config);
        }
    }
}

var detectAdBlockPromise,
    detectAdBlockResolve;

function detectAdBlock() {
    if (!detectAdBlockPromise) {
        detectAdBlockPromise = new Promise(function (resolve) {
            detectAdBlockResolve = resolve;
        });
    }

    return detectAdBlockPromise;
}

/**
 * Отслеживаем адблок на странице. Если он стоит, то принимаем меры для его обхода
 */
function setUp(cfg) {

    checkWeb2k19();

    /* Отслеживаем обновления главного контентного блока */
    var mainContentBlock = document.getElementById(containerIds.hookBlockMainContent);

    if (mainContentBlock) {
        if (MO) {
            var observer = new MO(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                        watchFeed();
                    }
                });
            });
            observer.observe(mainContentBlock, {childList: true});
        }
    }

    watchFeed();

    Promise.all([hooksReady, detectAdBlock()]).then(function (results) {
        if (results[1]) {
            attachBottomLeftBanner();
            attachDiscussionsBanner();
            attachMessagesBanner();
        }
    });
}

/**
 * Прикрепляет банер к диалоговому окну Обсуждения.
 */
function attachDiscussionsBanner() {

    var discHook = document.getElementById('hook_ToolbarIconDiscussions_ToolbarDiscussions');
    var mo = new MO(function(mutations) {
        mutations.forEach(function(mutation) {
            var name = mutation.attributeName;
            if (name === 'class') {
                // Не цепляемся к диалоговому окну, если 4-я колонка отключена.
                if (!OK.util.is4ColumnActive())
                    return;

                // В зависимости от активного элемента выбираем, куда прикреплять баннер.
                if (mutation.target.classList.contains('toolbar_nav_a__discu__active')) {
                    var panel = get1st(document, 'topPanel_d');
                    if (panel) {
                        var wrapper = get1st(panel, 'dialogWrapperBanner');
                        var adPlace = wrapper ? get1st(wrapper, 'dialogWrapperBanner__inner') : null;
                        if (adPlace && adPlace.innerHTML === '') {
                            showDirectBlock(adPlace, wrapper, 'discussion');
                        }
                    }
                }
            }
        });
    });

    if (discussionsBannerEnabled && discHook) {
        mo.observe(discHook, { attributes: true });
    }
}

/**
 * Прикрепляем баннер к диалоговому окну сообщений.
 */
function attachMessagesBanner() {

    var msgLayerWrapper = document.getElementById('msg_layer_wrapper');
    var messagesLayer = document.getElementById('hook_Block_MessagesLayer');

    if (!messagesBannerEnabled || !messagesLayer || !msgLayerWrapper) {
        return;
    }

    // Прикрепляем баннер.
    var triggerBanner = function(show) {
        var adCont = document.getElementById('hook_Block_MessagesAdsPanel');
        var adPlace = document.getElementById('hook_BannerNew_MessagesAdsPanelInner') || document.getElementById('MessagesAdsPanelInner');
        if (adCont && adPlace) {
            if (show) {
                if (OK.util.is4ColumnActive()) {
                    showDirectBlock(adPlace, adCont, 'message');
                }
            } else {
                setDisplayNone(adCont);
            }
        }
    };

    // Следим за подгрузкой основного контента диалогового окна.
    var ajaxContObserver = new MO(function(mutations) {
        triggerBanner(true);
        ajaxContObserver.disconnect();
    });
    ajaxContObserver.observe(messagesLayer, {childList: true});

    // Следим за скрытием/показом диалогового окна.
    var showObserver = new MO(function(mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'class') {
                triggerBanner(!mutation.target.classList.contains('invisible'));
            }
        });
    });
    showObserver.observe(msgLayerWrapper, {attributes: true});
}

/**
 * Выполняет функцию showFunction один и более раз, через промежуток времени refreshInterval[bannerType] при условии,
 * если баннерное место adPlace не исчезло при ajax-переходе и не скрыто.
 */
function showWithAutoRefresh(bannerType, adPlace, showFunction) {
    showFunction();
    var interval = refreshInterval[bannerType];
    if (refreshEnabled && interval > 0) {
        window.setTimeout(function() {
            if (document.body.contains(adPlace) && adPlace.offsetParent) {
                showWithAutoRefresh(bannerType, adPlace, showFunction);
            }
        },
        interval * 1000);
    }
}

/**
 * Скачивает и прикрепляет баннер как дочерний элемент к adPlace.
 * Тип баннера задается значением bannerPlace.
 * После прикрепления, всем элементам DOM-дерева по пути от adPlace до adCont проставляется видимость,
 * и вызывается функция afterAction.
 */
function showDirectBlock(adPlace, adCont, bannerPlace, afterAction) {
    cleanHooks();

    return new Promise(function (resolve) {
        showWithAutoRefresh(bannerPlace, adPlace, function() {

            var transport = new AjaxTransport();

            transport.getAds(bannerPlace)
                .then(function (resp) {
                    var smokescreen = (bannerPlace === 'topRight' && smokescreenTopRightEnabled)
                        || (bannerPlace === 'bottomLeft' && smokescreenBottomLeftEnabled);

                    var narrowLeftColumn = (bannerPlace === 'bottomLeft') && adPlace.classList.contains('__narrow');
                    adPlace.narrow = narrowLeftColumn;

                    var count = appendAd(adPlace, resp.result, numAds[bannerPlace], bannerPlace, smokescreen);
                    adjustDOM(adPlace, adCont, bannerPlace, function () {
                        if (afterAction) {
                            var newCount = afterAction(adPlace);
                            if (newCount >= 0) {
                                count = newCount;
                            }
                        }
                        logger.success(LogSuccess, 'showDirectAd', count);
                        if (count > 0) {
                            zeroPixel(resp.id, pixelId[bannerPlace]);
                            var countKey = getCountKey(resp.result, count);
                            transport.sendCount(bannerPlace, countKey).then(cleanup, cleanup);
                        } else {
                            cleanup();
                        }

                        resolve();
                    });
                });

            function cleanup() {
                transport.cleanup();
            }
        });
    });
}

/**
 * Прикрепляет правый верхний баннер (над друзьями онлайн)
 *
 * @param topRightAdCont - #fourthColumnWrapper
 * @param adPlace - #hook_BannerForthColumn_ForthColumnTopBannerInner
 *
 */
function attachTopRightBanner(topRightAdCont, adPlace) {

    if (!topRightBannerEnabled || !topRightAdCont || !adPlace) {
        return Promise.reject();
    }

    return showDirectBlock(adPlace, topRightAdCont, 'topRight');

}


function attachBottomLeftBanner() {
    if (!bottomLeftBannerEnabled) return;

    checkWeb2k19();

    var getAdPlace = function () {
        return document.getElementById(LeftGwtBannerPlaceId)
            || document.getElementById(LeftRbExtBannerPlaceId)
            || document.querySelector('#hook_Block_ViewportHeightAwareBanner .banner_new__vha');
    };

    var adCont = document.getElementById(containerIds.leftAdCont);
    var adPlace = getAdPlace();
    if (!adPlace || !adCont) {
        return;
    }
    var stickyActivateNeeded = false;
    if (adPlace.id === LeftRbExtBannerPlaceId) {
        var controller = get1stWithLocator(adPlace, 'banner-controller');
        if (controller) {
            stickyActivateNeeded = (controller.getAttribute('data-sticky-banner') === 'true');
        }
    }

    var attachBlock = function(adPlace, adCont) {
        showDirectBlock(adPlace, adCont, 'bottomLeft',
            function() {
                /* Прячем рекламные блоки, которые не попадут в поле видимости по высоте окна */
                var adList = get1stWithLocator(adPlace, 'b-context');
                var len = adList.children.length;
                var totalHeight = 0;
                var numShown = 0;
                for (var idx = 0; idx < len; ++idx) {
                    var ad = adList.children[idx];
                    totalHeight += ad.offsetHeight;
                    if (totalHeight > window.innerHeight * 0.65) {
                        ad.classList.add(locator.transform('b-invisible'));
                    } else {
                        numShown++;
                    }
                }

                var isRbExtBanner = (adPlace.id === LeftRbExtBannerPlaceId);
                if (isRbExtBanner) {
                    // для rbExt-баннера активируем механизм "липучки" только после первого получения баннеров от mimic
                    if (stickyActivateNeeded) {
                        var hookBlock = dom.parent(adPlace, 'hookBlock');
                        if (hookBlock) {
                            StickyBannerContainer.activate(hookBlock);
                        }
                        stickyActivateNeeded = false;
                    }
                } else {
                    /* Дергаем баннерный хук, чтобы баннер сполз на нужное место. */
                    var hookObj = getHookObjWithLocator("stickyBannerHook");
                    if (hookObj) {
                        hookObj.doReflow();
                    }
                }

                return numShown;
            }
        );
    };

    var attachBlockIfNeeded = function() {
        var adPlace = getAdPlace();
        var adCont = document.getElementById(containerIds.leftAdCont);
        if (adPlace && adCont) {
            attachBlock(adPlace, adCont);
        }
    };

    if (MO) {
        // Следим за сменой основного контентного блока.
        var bottomAdObserver = new MO(function(mutations) {
            var attached = false;
            mutations.forEach(function(mutation) {
                if (attached) {
                    return;
                }
                var name = mutation.attributeName;
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    attachBlockIfNeeded();
                    attached = true;
                }
            });
        });

        var adUberCont = document.getElementById(containerIds.hookBlockMainContent);
        bottomAdObserver.observe(adUberCont, {childList: true});


        // следим за сменой старого и нового дизайна и заново подписываемся на изменения
        var redesignObserver = new MO(function(mutations) {
            var attached = false;
            mutations.forEach(function(mutation) {
                if (attached) {
                    return;
                }
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    checkWeb2k19();
                    var adUberCont = document.getElementById(containerIds.hookBlockMainContent);
                    if (adUberCont) {
                        bottomAdObserver.observe(adUberCont, {childList: true});
                        attachBlockIfNeeded();
                        attached = true;
                    }
                }
            });
        });

        var mainContentWrapper = document.getElementById('hook_Block_MainContentWrapper');
        if (mainContentWrapper) {
            redesignObserver.observe(mainContentWrapper, {childList: true});
        }


    }

    attachBlock(adPlace, adCont);
}

/**
 * Формирует тело запроса к мимику
 */
function jsonrpc(method, params) {
    var rid = Date.now() + Math.floor((Math.random() * 10000) + 1);
    params.location = debugOrigin || window.location.href;
    params.agent = navigator.userAgent;
    return {
        jsonrpc: "2.0",
        method: method,
        params: params,
        id: rid
    };
}

/**
 * Проверяет ответ, который вернул сервис Мимика
 */
function parseResponse(method, json) {
    return new Promise(function (resolve, reject) {
        var resp;
        try {
            resp = JSON.parse(json);
        } catch (e) {
            logger.success(LogError, 'parseError');
            reject();
            return;
        }
        if (resp && resp.error) {
            logger.success(LogError, method + '.respError', resp.error);
            reject();
            return;
        }
        if (!resp || !resp.result || !resp.id) {
            logger.success(LogError, method + '.badPayload');
            reject();
            return;
        }
        if (resp.result.status !== 200) {
            logger.success(LogError, method + '.badStatus', resp.result.status);
            reject();
            return;
        }
        resolve(resp);
    });
}

function processPage(json) {
    return parseResponse('page', json);
}

function processCount(json) {
    return parseResponse('count', json);
}

function AjaxTransport() {
    var url = "/dk";
    var getAds = function (bannerPlace) {
        var body = "cmd=" + secretCmd + "&gwt.requested=" + window.pageCtx.gwtHash + "&mt=page&pl=" + window.encodeURIComponent(bannerPlace);
        return vanilla.ajax({
            url: url,
            data: body,
            headers: {"Content-Type": "application/x-www-form-urlencoded"}
        }).then(function (data) {
              return processPage(data.response);
        }, function (xhr) {
                logger.success(LogError, "xhrErr", xhr.status);
        });
    };

    //OL-82170 bypass Adguard's set-constant scriptlet
    Object.defineProperty(this, "getAds", {
        value: getAds
    });

    this.sendCount = function (bannerPlace, count) {
        var body = "cmd=" + secretCmd + "&gwt.requested=" + window.pageCtx.gwtHash + "&mt=count&pl=" + bannerPlace + "&cnt=" + window.encodeURIComponent(count);
        return vanilla.ajax({
            url: url,
            data: body,
            headers: {"Content-Type": "application/x-www-form-urlencoded"}
        }).then(function (data) {
            return processCount(data.response);
        });
    };

    this.cleanup = function() {};
}

/**
 * Вставляет рекламный банер в нужно место.
 */
function appendAd(parentNode, data, limit, bannerPlace, smokescreen) {
    if (!data || !data.body || !data.body.direct || !data.body.direct.ads) {
        logger.success(LogError, "badDirectBlock");
        return;
    }
    var adHtml = "";
    var directAds = data.body.direct.ads;
    var count = 0;

    if (directAds.length === 0) {
        // Cитуация, когда не смогли подобрать рекламу (актуально для версии РБ)
        logger.success(LogError, "emptyAds");
        return 0;
    } else {
        for (var i = 0; i < directAds.length; ++i) {
            if (i >= limit) {
                break;
            }
            var ad = directAds[i];
            if (!ad) {
                continue;
            }
            adHtml += makeTemplate(ad, smokescreen, bannerPlace, parentNode.narrow);
            count++;
        }
    }
    if (adHtml && parentNode) {
        var options = data.body.common
            ? {
                common: data.body.common
            }
            : {
                common: {}
            };

        parentNode.innerHTML = tpl(
            '<div class="b-context b-js__hook" data-msh="ad" data-options="' + esc(JSON.stringify(options))  +'">',
                adHtml,
            '</div>'
        );
    }
    return count;
}

/**
 * Получает ключ для отправки в запросе о количестве показанных баннеров
 */
function getCountKey(data, numAds) {
   var directAds = data.body.direct.ads;
   var count = data.body.common.link_head.replace(/^.+\/count\//, '');
   for (var i = 0; i < numAds; ++i) {
       count += directAds[i].link_tail;
   }
   return count;
}

/**
 * Формирует пиксель для статистики показа банера
 */
function zeroPixel(rnd, pixel) {
    new Image().src = '//rs.mail.ru/d' + pixel + '.gif?rnd='+ rnd + '&ts=' + Date.now();
}

/**
 * Формирует пиксель для статистики показа банера
 */
function sendPixel(url) {
    if (sendPixelsThroughServer) {
        var data = "cmd=" + secretCmd
            + "&gwt.requested=" + window.pageCtx.gwtHash
            + "&mt=pixel&u=" + window.encodeURIComponent(url);
        return vanilla.ajax({
            url: '/dk',
            data: data,
            headers: {"Content-Type": "application/x-www-form-urlencoded"}
        });
    } else {
        new Image().src = url;
    }
}

/**
 * Эскейпинг спецсимволов HTML
 * @param {boolean} doNotSkipEncoded
 */
var escHtml = function(doNotSkipEncoded) {
    var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;" },
        matchHTML = doNotSkipEncoded ? /[&<>"']/g : /&(?!#?\w+;)|<|>|"|'/g;
    return function(code) {
        return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
    };
};

var esc = escHtml(false);

function tpl() {
    return Array.prototype.slice.call(arguments).join('');
}

function tplIf(value, html) {
    return (value || '') && html;
}

function createChar(text, isFake) {
    var rnd = Math.random(),
        char = esc(text);
    if (isFake) {
        if (rnd <= 0.33) {
            return tpl(
                '<div class="ads_char __fake">',
                    char,
                '</div>'
            );
        } else if (rnd < 0.66) {
            return tpl(
                '<span class="ads_char __fake">',
                    char,
                '</span>'
            );
        } else {
            return '';
        }
    }
    if (rnd <= 0.33) {
        return tpl(
            '<span class="ads_char">',
                char,
            '</span>'
        );
    } else if (rnd < 0.66) {
        return tpl(
            '<div class="ads_char">',
                char,
            '</div>'
        );
    } else {
        return char;
    }
}

// Преобразуем слова "Реклама" в несколько span.ads_char,
// с буквами Р, е, к, л, а, м, а
// Эти span перемешиваем со span.ads_char.__fake, которые
// содержат в себе случайные символы
// Все это обфусцируется, чтобы AdBlock не нашел рекламу по тексту
function obfuscateText(title) {
    var result = [];

    // формируем слово Реклама по буквам
    for (var j = 0; j < title.length; j++) {
        // создаем одну букву от слова
        result.push(createChar(title[j]));
        // дополняем её фэйковой буквой
        result.push(
            createChar(
                String.fromCharCode(97 + Math.round(Math.random() * 30)),
                true
            )
        );
    }

    return result.join('')
}

/**
 * Создает HTML-код банера со всеми нужными стилями и проч
 * @param {Object} item
 * @return {string}
 */
function makeTemplate(item, smokescreen, bannerPlace, narrow) {
    if (smokescreen) {
        var imgIdx = -1;
        var haveImg = false;
        var tplV2 = tplV2Enabled && (bannerPlace === 'bottomLeft');

        if (item.images && item.images[0]) {

            var width = +item.images[0][1],
                height = +item.images[0][2];

            var maxColumnWidth = narrow ? 176 : 200;
            var maxImgWidth = tplV2 ? maxColumnWidth : 90;

            if (width > maxImgWidth) {
                height = height * maxImgWidth / width;
                width = maxImgWidth;
            }

            if (tplV2) {
                if (width < maxImgWidth) {
                    height = height * maxImgWidth / width;
                    width = maxImgWidth;
                }
            }

            imgIdx = imageStyles[bannerPlace].registerImageStyle(width, height, esc(item.images[0][0]));
            haveImg = true;
        }

        var menu = tplIf(item.adChoices, tpl(
            '<div class="b-context__close b-js__hook" data-msh="close">',
                '<div class="b-context__close-menu">',
                    '<div class="b-context__close-menu_cnt">',
                        item.adChoices.options
                            .map(function(option) {
                                return tpl(
                                    '<div class="b-context__close-menu_i b-js__hook" data-msh="closeLink" data-options="' + esc(JSON.stringify(option)) + '">',
                                        esc(option.name),
                                    '</div>',
                                );
                            })
                            .join(''),
                    '</div>',
                    '<div class="b-context__close-menu_arw_w">',
                        '<div class="b-context__close-menu_arw"></div>',
                    '</div>',
                '</div>',
            '</div>'
        ));

        if (tplV2) {

            return tpl(
                '<div class="b-context__item b-context__item__v2 b-js_ad">',
                    tplIf(haveImg, tpl(
                        '<div class="b-context__picture-w">',
                            '<div class="b-context__picture b-js__hook b-img-' + bannerPlace + imgIdx + '" data-msh="link" data-nbh="' + esc(item.url) + '">',
                                '<span class="b-context__marker">',
                                    obfuscateText('Реклама'),
                                '</span>',
                                '<div class="b-context__contacts b-js__hook" data-msh="link" data-nbh="' + esc(item.url) + '">',
                                    esc(item.domain),
                                    tplIf(item.region, tpl(
                                        '<span class="b-context__contacts__item">',
                                            esc(item.region),
                                        '</span>'
                                    )),
                                '</div>',
                            '</div>',
                            menu,
                        '</div>'
                    )),
                    '<div class="b-context__title">',
                        '<div class="b-context__title__link b-js__hook" data-msh="link" data-nbh="' + esc(item.url) + '">',
                            tplIf(item.puny_domain, tpl(
                                '<img class="b-context__favicon" src="//favicon.yandex.net/favicon/' + esc(item.puny_domain) + '" alt=""/>'
                            )),
                            esc(item.title),
                        '</div>',
                        tplIf(!haveImg, menu),
                    '</div>',
                    '<div class="b-context__content b-context__content__link b-js__hook" data-msh="link" data-nbh="' + esc(item.url) + '">',
                        esc(item.body),
                    '</div>',
                    tplIf(item.warning, tpl(
                        '<div class="b-context__warning">',
                            esc(item.warning),
                        '</div>'
                    )),
                '</div>'
            );
        } else {
            return tpl(
                '<div class="b-context__item b-js_ad">',
                    '<div class="b-context__title">',
                        '<div class="b-context__title__link b-js__hook" data-msh="link" data-nbh="' + esc(item.url) + '">',
                            tplIf(item.puny_domain, tpl(
                                '<img class="b-context__favicon" src="//favicon.yandex.net/favicon/' + esc(item.puny_domain) + '" alt=""/>'
                            )),
                            esc(item.title),
                        '</div>',
                        menu,
                    '</div>',
                    tplIf(imgIdx >= 0, tpl(
                        '<div class="b-context__picture b-js__hook b-img-' + bannerPlace + imgIdx + '" data-msh="link" data-nbh="' + esc(item.url) + '">',
                            '<span class="b-context__marker">',
                                obfuscateText('Реклама'),
                            '</span>',
                        '</div>'
                    )),
                    '<div class="b-context__content b-context__content__link b-js__hook" data-msh="link" data-nbh="' + esc(item.url) + '">',
                        esc(item.body),
                    '</div>',
                    '<div class="b-context__contacts b-context__contacts__item b-context__contacts__item_link b-js__hook" data-msh="link" data-nbh="' + esc(item.url) + '">',
                        esc(item.domain),
                        tplIf(item.region, tpl(
                            '<span class="b-context__contacts__item">',
                                esc(item.region),
                            '</span>'
                        )),
                    '</div>',
                    tplIf(item.warning, tpl(
                        '<div class="b-context__warning">',
                            esc(item.warning),
                        '</div>'
                    )),
                '</div>'
            );
        }

    } else {
        var favString = item.puny_domain ? '<img class="b-context__favicon" src="//favicon.yandex.net/favicon/' + esc(item.puny_domain) + '" alt=""/>' : '';
        var tlString = '<div class="b-context__title"><a class="b-context__title__link" href="' + esc(item.url) + '" target="_blank">' + favString + esc(item.title) + '</a></div>';
        var imgString = (item.images && item.images[0]) ? '<div class="b-context__picture"><a href="' + esc(item.url) + '" target="_blank"><img src="' + esc(item.images[0][0]) + '" width="' + esc(item.images[0][1]) + '" height="' + esc(item.images[0][2]) + '" alt=""/></a></div>' : '';
        var ctxString = '<div class="b-context__content"><a class="b-context__content__link" href="' + esc(item.url) + '" target="_blank">' + esc(item.body) + '</a></div>';
        var regionString = item.region ? '<span class="b-context__contacts__item">' + esc(item.region) + '</span>' : '';
        var contactsString = '<div class="b-context__contacts"><a class="b-context__contacts__item b-context__contacts__item_link" href="' + esc(item.url) + '" target="_blank">' + esc(item.domain) + '</a>' + regionString + '</div>';
        var warningString = item.warning ? '<div class="b-context__warning">' + esc(item.warning) + '</div>' : '';
        return '<div class="b-context__item">' + tlString + imgString + ctxString + contactsString + warningString + '</div>';
    }
}

function onJsLinkClick(link, bannerPlace, event) {
    if (link) {
        openLink(link, bannerPlace);
        event.stopPropagation();
    }
}

function openLink(link, bannerPlace) {
    logger.success(LogSuccess, bannerPlace, "click");

    if (adLinksRedirectWrapperEnabled) {
        var redirectLink = "/dk?cmd=logExternal&st.name=externalLinkRedirect&st.link=" +
            window.encodeURIComponent(link) + "&st.sig=" + redirectLinkToken;
        var tab = window.open(redirectLink);

        var doRedirect = function() {
            tab.location.href = link;
            tab.removeEventListener('load', doRedirect);
        };

        tab.addEventListener('load', doRedirect, false);

    } else {
        window.open(link);
    }
}

/**
 * Создает абсолютный урл из относительного или абсолютного
 */
function makeAbsoluteUrl(urls) {
    if (!urls) return null;

    if (!Utils.isUrlConstructorExists()) return null; // если вдруг IE

    var res = [];
    urls.forEach(function(url) {
        res.push(new URL(url, window.location.href).href);
    });
    return res;
}

function activateScript(cfg) {
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
        setUp(cfg);
    } else {
        document.addEventListener('DOMContentLoaded', function () {
            setUp(cfg);
        });
    }

    onActivated();
}

function activateMoneyHandler() {
    activateScript();
    ACTIVATE_MONEY_SAVE.off(activateMoneyHandler);
}

function activate(element) {

    var cfg = element.getAttribute('data-config');

    if (cfg[0] !== '{') {
        cfg = atob(cfg);
    }

    cfg = JSON.parse(cfg);

    if (cfg.removeEl) {
        // усложняем жизнь адгуарду
        element.parentNode.removeChild(element);
    }

    mimicUrl = cfg.mimicUrl || mimicUrl;
    tplV2Enabled = cfg.tplV2Enabled || false;
    topRightBannerEnabled = cfg.topRightBannerEnabled || false;
    messagesBannerEnabled = cfg.messagesBannerEnabled || false;
    discussionsBannerEnabled = cfg.discussionsBannerEnabled || false;
    bottomLeftBannerEnabled = cfg.bottomLeftBannerEnabled || false;
    statId = cfg.statId || statId;
    pixelId = cfg.pixelId || pixelId;
    refreshEnabled = cfg.refreshEnabled || false;
    refreshInterval = cfg.refreshInterval || refreshInterval;
    pageId = cfg.pageId || pageId;
    whitelistSelector = cfg.whitelistSelector || whitelistSelector;
    secretCmd = cfg.secretCmd || "";
    secretFeedReplaceCmd = cfg.secretFeedReplaceCmd || "";
    useHttp = cfg.useHttp || false;
    debugOrigin = cfg.debugOrigin;
    smokescreenTopRightEnabled = cfg.smokescreenTopRightEnabled || false;
    smokescreenDiscussionsEnabled = cfg.smokescreenDiscussionsEnabled || false;
    smokescreenMessagesEnabled = cfg.smokescreenMessagesEnabled || false;
    smokescreenBottomLeftEnabled = cfg.smokescreenBottomLeftEnabled || false;
    smokescreenRandomizeCss = cfg.smokescreenRandomizeCss || false;
    adLinksRedirectWrapperEnabled = cfg.adLinksRedirectWrapperEnabled;
    redirectLinkToken = cfg.redirectLinkToken;
    redesignEnabled = cfg.redesignEnabled;
    sendPixelsThroughServer = cfg.sendPixelsThroughServer;
    hideBannersUnderLayer = cfg.hideBannersUnderLayer;

    locatorLinks = makeAbsoluteUrl(cfg.cssUrls);
    activateMoneyHandler = activateMoneyHandler.bind(this, cfg);

    if (!hideBannersUnderLayer) {
        activateScript(cfg);
    } else {
        ACTIVATE_MONEY_SAVE.on(activateMoneyHandler, this);
    }


    blockDetect(cfg).then(function (value) {
        detectAdBlockResolve(value);
    });
}

let version = 1;

function ready() {
    return Promise.all([
        hooksReady,
        detectAdBlock(),
        activateLocator()
    ]);
}

function obfuscate(container, skipNodes, skipContainer) {
    return activateLocator().then(function () {
        obfuscateChildren(container, skipNodes, skipContainer);
    });
}

function transform(className) {
    return activateLocator().then(function () {
        return locator.transform(className)
    });
}

function transformNow(className) {
    return locator.transform(className)
}

function activateLocator$1() {
    return activateLocator();
}

function getSecretFeedReplaceCmd() {
    return secretFeedReplaceCmd;
}

export default { version, activate, ready, onHooksReady, detectAdBlock, obfuscate, obfuscateNow: obfuscateChildren, obfuscateText, transform, transformNow, activateLocator: activateLocator$1, openLink, attachTopRightBanner, getSecretFeedReplaceCmd };

export { version, activate, ready, onHooksReady, detectAdBlock, obfuscate, obfuscateChildren as obfuscateNow, obfuscateText, transform, transformNow, activateLocator$1 as activateLocator, openLink, attachTopRightBanner, getSecretFeedReplaceCmd };
